export default __webpack_public_path__ + "static/media/baer_one.c799be88.jpg";